import { z } from 'zod';
import { FiltersSchema } from './filtersSchema';
import { AnalyticsSchema } from './analyticsSchema';
import { StringNumberSchema } from './primitivesSchema';
import { validateRange } from './schemaUtils';
import filters from '@/config/filters';

// Parameters used only in /api/apartments calls
const ApiSpecificFilterSchema = z.object({
  group: StringNumberSchema.optional(),
  limit: StringNumberSchema.refine(
    validateRange(0, filters.FILTER_DEFAULTS.limit),
    'limit not within range'
  ).optional(),
  offset: StringNumberSchema.refine(validateRange(0, 99999), 'offset not within range').optional(),
});

// Basic schema for all urls. Analytics parameters can be added to any url.
export const BasicUrlSchema = AnalyticsSchema;

// Schema for search urls
export const SearchUrlSchema = AnalyticsSchema.merge(FiltersSchema);

// Schema for /api/apartments requests
export const ApiUrlSchema = FiltersSchema.merge(ApiSpecificFilterSchema);
